import { Component } from '@angular/core';
import { PageService, SortService, FilterService, ResizeService, FreezeService } from '@syncfusion/ej2-angular-grids';
import { ExpectFundResponseDto } from '../../shared/models/expectResponseDto';
import { ViewUserExpectComponent } from '../../view-user-expect/view-user-expect.component';
import { RequestType } from '../../enums/request-type.enum';
import { ServerPagedHistoryGrid } from '../../shared/grid/server-paged-history-grid';
import type { GridFields } from '../../shared/utils/grid-request';

@Component({
    selector: 'xp-user-expect-history',
    templateUrl: './user-expect-history.component.html',
    styleUrl: './user-expect-history.component.scss',
    providers: [PageService, SortService, FilterService, ResizeService, FreezeService]
})
export class UserExpectHistoryComponent extends ServerPagedHistoryGrid<ExpectFundResponseDto> {
    protected readonly requestType = RequestType.ExpectFunds;
    protected readonly path = 'expect-fund';
    protected readonly completedRoute = 'expect-fund-completed';
    protected readonly filterKey = 'expect-fund';
    protected readonly sheetName = 'Expect Fund Requests';
    protected readonly exportFileName = 'User Receipt Requests';
    protected readonly fields: GridFields = {
        id: 'number',
        dateRequested: 'date',
        matterNo: 'number',
        matter: 'text',
        clientName: 'text',
        currencyCode: 'text',
        expectedAmount: 'number',
        clientBankAccountName: 'text',
        payerName: 'text',
        paymentReason: 'text',
        partnerAuthorisingName: 'text',
        dateAuthorised: 'date',
        dateTransaction: 'date',
        recentStatus: 'text',
        returnReason: 'text'
    };

    viewExpectFund(request: ExpectFundResponseDto): void {
        this.openDetails(ViewUserExpectComponent, request, '90%');
    }

    protected exportRow(item: ExpectFundResponseDto): Record<string, unknown> {
        const row: Record<string, unknown> = {
            'Request Id': item.id || '',
            'Requested Date': this.exportDate(item.dateRequested),
            'Matter No': item.matterNo || '',
            'Matter': item.matter || '',
            'Client': item.clientName || '',
            'Payer Name': item.payerName || '',
            'Currency': item.currencyCode ?? '',
            'Expected Amount': item.expectedAmount ?? '',
            'Partner': item.partnerAuthorisingName || '',
            'Date Authorised': this.exportDate(item.dateAuthorised),
            'Transaction Date': this.exportDate(item.dateTransaction),
            'Status': item.recentStatus || ''
        };
        if (this.isCompletedTab) {
            row['Reason for Payment'] = item.paymentReason || '';
            row['Client Bank Account Name'] = item.clientBankAccountName || '';
            row['Rejected Reason'] = item.returnReason || '';
        }
        return row;
    }
}
